import React from 'react';
import cn from 'classnames';
import { Button as ButtonAntd, ButtonProps as AntdButtonProps } from 'antd';
import { BUTTON_TYPES } from './constants';
import { ButtonProps } from './types';
import './style.scss';

export const Button: React.FC<ButtonProps> = ({
  children,
  className,
  type = BUTTON_TYPES.SECONDARY,
  variant,
  ...props
}) => (
  <ButtonAntd className={cn('button-default', { 'button-grey': variant === 'grey' }, className)} type={type} {...props}>
    {children}
  </ButtonAntd>
);
